import React, { useState, useEffect } from "react";
import SecurityIcon from "../../assets/png/security.png";
import Security from "../../assets/svg/security.svg";
import CommonModal from "../Modals/CommonModal";
import TwoFaSidebar from "../../Components/Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import { servicePost } from "../../helper/api";
import Navbar from "../../Components/Navbar/Navbar";
import Button from "../../Components/UIComponents/Button";

const EnableTwofa = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("wealth_user"))?.data
  );
  const [inputValues, setInputValues] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [showBtn, setShowBtn] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  // Function to toggle the checked state
  const toggleChecked = () => {
    setIsChecked(!isChecked);
    toggleClass();
    setShowBtn(!showBtn);
  };

  const checkPin = () => {
    const inputElements = [...document.querySelectorAll("input.code-input")];
    inputElements.forEach((ele, index) => {
      ele.addEventListener("keydown", (e) => {
        if (e.keyCode === 8 && e.target.value === "") {
          inputElements[Math.max(0, index - 1)].focus();
        }
      });
      ele.addEventListener("input", (e) => {
        const [first, ...rest] = e.target.value;
        e.target.value = first ?? "";
        const lastInputBox = index === inputElements.length - 1;
        const didInsertContent = first !== undefined;
        if (didInsertContent && !lastInputBox) {
          inputElements[index + 1].focus();
          inputElements[index + 1].value = rest.join("");
          inputElements[index + 1].dispatchEvent(new Event("input"));
        }

        const code = inputElements.map(({ value }) => value).join("");
        setInputValues(code);
      });
      ele.addEventListener("paste", (e) => {
        e.preventDefault();
        const paste = e.clipboardData.getData("text").slice(0, 6);
        paste.split("").forEach((char, i) => {
          inputElements[i].value = char;
          inputElements[i].dispatchEvent(new Event("input"));
        });
      });
    });
  };

  useEffect(() => {
    checkPin();
  }, [inputValues, showBtn]);

  const navigate = useNavigate();
  useEffect(() => {
    if (modalShow) {
      setTimeout(function () {
        navigate("/disable-request");
        setModalShow(false);
      }, 2000);
    }
  }, [modalShow]);
  const [twoFaCode, setTwoFaCode] = useState({
    twoFaCode1: "",
    twoFaCode2: "",
    twoFaCode3: "",
    twoFaCode4: "",
    twoFaCode5: "",
    twoFaCode6: "",
  });

  const submitTwoFaReq = async () => {
    navigate("/twofaguide");
    return;

    try {
      if (inputValues.length < 6) {
        setError(true);
        setErrorMessage("Fill all fields");
        setTimeout(() => {
          setErrorMessage("");
          setError(false);
        }, 5000);
        return;
      }

      setIsLoading(true);
      const submitTwaFa = await servicePost(
        "admin2fa/twofactorverified",
        {
          user: user.email,
          token: inputValues,
        },
        notification,
        authToken
      );

      if (submitTwaFa.data === true) {
        setIsLoading(false);
        setShowConfirmationModal(true);
        const updatedUser = {
          ...user,
          enableOn: true,
          twoFaVerified: true,
        };

        localStorage.setItem(
          "wealth_user",
          JSON.stringify({ data: updatedUser })
        );
        navigate("/disable-twofa");
      } else {
        setIsLoading(false);
        setError(true);
        setErrorMessage("Authentication code expired.");
        setTimeout(() => {
          setErrorMessage("");
          setError(false);
        }, 5000);
      }
    } catch (error) {
      setIsLoading(false);
      setError(true);
      setErrorMessage("Something went wrong.");
      setTimeout(() => {
        setErrorMessage("");
        setError(false);
      }, 5000);
    }
  };

  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const twoFaChangeHandler = (e) => {
    const { name, value } = e.target;
    setTwoFaCode((preVal) => {
      return {
        ...preVal,
        [name]: value,
      };
    });
  };
  const toggleClass = () => {
    // $(".hideshow-code").addClass("show");
  };

  const cancelCode = () => {
    setIsChecked(false);
    setShowBtn(true);
  };

  return (
    <>
      <CommonModal
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)}
        type="Two-Factor Authentication Enable successfully"
      />
      <Navbar />
      <TwoFaSidebar />
      <div className="twofa-guide-wrapper navbar-space-wrapper admin-sidebar-space">
        <div className="container">
          <div className="transfer-history-header">
            <img src="./images/icons/auth-logo.png" alt="icon" />
            <h3 className="twofa-desktop"> Two-Factor Authentication</h3>
            <h3 className="twofa-mobile-header"> 2F Authentication</h3>
          </div>

          <div className="twofa-enable-wrapper dashboard-twofa-enable-wrapper">
            <div className="twofa-status-wrapper">
              <img src="./images/twofa-disable-req.png" alt="icon" />
              <p className="twofa-status"> Status</p>
              <h2 className="twofa-status-desabled"> TWO-FACTOR DISABLED </h2>

              <div className="disable-twofa-input-wrap">
                <input
                  type="checkbox"
                  id="switch"
                  checked={isChecked}
                  onChange={toggleChecked}
                />
                <label for="switch">Toggle</label>
                <p> Enable 2FA </p>
              </div>
            </div>

            {/* {!showBtn && (
              <div className="hideshow-code">
                <div className="enable-pin-code-input pin-code password-otp-input">
                  <input
                    className="code-input"
                    type="number"
                    maxLength="1"
                    name="twoFaCode1"
                    autoFocus
                  />
                  <input
                    className="code-input"
                    type="number"
                    maxLength="1"
                    name="twoFaCode2"
                  />
                  <input
                    className="code-input"
                    type="number"
                    maxLength="1"
                    name="twoFaCode3"
                  />
                  <input
                    className="code-input"
                    type="number"
                    maxLength="1"
                    name="twoFaCode4"
                  />
                  <input
                    className="code-input"
                    type="number"
                    maxLength="1"
                    name="twoFaCode5"
                  />
                  <input
                    className="code-input"
                    type="number"
                    maxLength="1"
                    name="twoFaCode6"
                  />
                </div>

                {error ? (
                  <div className="error-msg">{errorMessage}</div>
                ) : (
                  <div className="enter-digit"> Enter your 6 digits Code </div>
                )}
              </div>
            )} */}

            <div className="twofa-footer">
              <div className="twofa-security-wrapper">
                <div className="twofa-security-wrap">
                  <img src={SecurityIcon} alt="icon" />
                  <p>
                    To enable 2FA, we'll verify your request. Account access and
                    2FA reset will be temporarily unavailable during
                    verification
                  </p>
                </div>
              </div>

              {isChecked ? (
                <div className="confirm-button-wrapper">
                  <div className="confirm-button-wrap">
                    <Button
                      isLoading={isLoading}
                      label="Confirm"
                      onClick={submitTwoFaReq}
                    />

                    <Button
                      extraClass="cancel-button"
                      label="Cancel"
                      onClick={cancelCode}
                    />
                  </div>
                </div>
              ) : (
                <div className="confirm-button-wrapper for-space-disaper-button">
                  <div className="confirm-button-wrap">
                    <button>Confirm</button>
                    <button className="cancel-button">Cancel</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnableTwofa;
